/*-------------- Colour theme (Dark / Light) ----------------*/
(function () {
    const STORAGE_KEY = 'huddled-theme';
    const root = document.documentElement;

    function storedTheme() {
        try {
            const theme = localStorage.getItem(STORAGE_KEY);
            if (theme === 'light' || theme === 'dark') {
                return theme;
            }
        } catch (e) {}
        return 'dark';
    }

    function applyTheme(theme) {
        const next = theme === 'light' ? 'light' : 'dark';
        root.setAttribute('data-theme', next);
        try {
            localStorage.setItem(STORAGE_KEY, next);
        } catch (e) {}
        document.querySelectorAll('[data-theme-toggle]').forEach(function (btn) {
            const isLight = next === 'light';
            btn.setAttribute('aria-checked', String(isLight));
            btn.setAttribute('aria-label', isLight ? 'Switch to dark colour theme' : 'Switch to light colour theme');
        });
    }

    function bindSwitch() {
        applyTheme(storedTheme());
        document.addEventListener('click', function (event) {
            const el = event.target instanceof Element ? event.target : event.target.parentElement;
            const toggle = el && el.closest('[data-theme-toggle]');
            if (!toggle) {
                return;
            }
            const current = root.getAttribute('data-theme') === 'light' ? 'light' : 'dark';
            applyTheme(current === 'light' ? 'dark' : 'light');
        });
    }

    applyTheme(storedTheme());

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bindSwitch);
    } else {
        bindSwitch();
    }
})();

/*-------------- On Scroll Functions ----------------*/
$(window).scroll(function(){
    // var scroll = $(window).scrollTop();
    // if (scroll >= 50) {
    //     $(".header").addClass("scrolled");
    // } else {
    //     $(".header").removeClass("scrolled");
    // }
});


document.addEventListener('DOMContentLoaded', () => {
    const scrollLinks = document.querySelectorAll('.scroll-anchor-link[data-scroll-to]');

    scrollLinks.forEach(link => {
        link.addEventListener('click', (e) => {
            e.preventDefault();

            const targetId = link.getAttribute('data-scroll-to');
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
                // Calculate position to center the element vertically in the viewport
                const elementRect = targetElement.getBoundingClientRect();
                const absoluteElementTop = elementRect.top + window.pageYOffset;
                const centerOffset = (window.innerHeight - elementRect.height) / 2;

                // Fallback to top scrolling if the component block is taller than the viewport itself
                const targetScrollPosition = centerOffset > 0 ? (absoluteElementTop - centerOffset) : absoluteElementTop;

                window.scrollTo({
                    top: targetScrollPosition,
                    behavior: 'smooth'
                });

                // Optional: Update browser address bar hash cleanly without snapping the page
                history.pushState(null, null, `#${targetId}`);
            }
        });
    });
});

$(document).ready(function(){
    $('.loadin-200').addClass('in-view');
    $('.loadin-400').addClass('in-view');
});

$(document).ready(function($) {
    const $tagline = $('#hero-tagline');
    const $dataSource = $('#tagline-data');

    if ($tagline.length && $dataSource.length) {
        const phrases = $dataSource.data('phrases');
        let currentIndex = 0;

        if (phrases && phrases.length > 1) {
            setInterval(function() {
                // Step 1: Fade out completely by changing opacity to 0
                $tagline.css({
                    'opacity': 0,
                    'transform': 'translateY(-8px)' // Muted upward lift
                });

                // Step 2: WAIT 400ms (matching your CSS transition duration) before swapping text
                setTimeout(function() {
                    currentIndex = (currentIndex + 1) % phrases.length;
                    $tagline.text(phrases[currentIndex]);

                    // Step 3: Fade in smoothly from its resting baseline position
                    $tagline.css({
                        'opacity': 1,
                        'transform': 'translateY(0)'
                    });
                }, 400); // This delay forces the text change to happen in total darkness

            }, 3500); // Rotates every 3.5 seconds
        }
    }
});


document.addEventListener('DOMContentLoaded', () => {
    const lightboxModal = document.getElementById('global-case-lightbox');
    const lightboxImg = document.getElementById('lightbox-main-viewpane');
    const closeBtn = document.querySelector('.lightbox-close-trigger');
    const galleryCards = document.querySelectorAll('[data-lightbox-target]');

    if (!lightboxModal || !lightboxImg) return;

    // Open Lightbox
    galleryCards.forEach(card => {
        card.addEventListener('click', () => {
            const highResSrc = card.getAttribute('data-lightbox-target');
            lightboxImg.setAttribute('src', highResSrc);
            lightboxModal.classList.add('is-active');
            document.body.style.overflow = 'hidden'; // Freeze site body scrolling background activities
        });
    });

    // Close Lightbox function
    const closeLightbox = () => {
        lightboxModal.classList.remove('is-active');
        document.body.style.overflow = ''; // Restore traditional scroll navigation layouts
        setTimeout(() => {
            lightboxImg.setAttribute('src', ''); // Flush image canvas cache safely
        }, 300);
    };

    // Close Click Events
    closeBtn.addEventListener('click', closeLightbox);
    lightboxModal.addEventListener('click', (e) => {
        if (e.target === lightboxModal) closeLightbox();
    });

    // Close on Escape keyboard key
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightboxModal.classList.contains('is-active')) {
            closeLightbox();
        }
    });
});

// TESTIMONIAL
$(document).ready(function() {
    const $slides = $('.testimonial-slide');
    const $progressBar = $('.slider-progress-bar');
    // UPDATED: Now targeting the white card element container specifically
    const $sliderCard = $('.text-outer__inner');

    if ($slides.length <= 1 || !$progressBar.length) return;

    let currentSlideIndex = 0;
    const totalDuration = 10000; // 10 seconds interval
    const frameRateInterval = 20;
    let elapsedTime = 0;
    let rotationTimer;

    function runSliderLifecycle() {
        elapsedTime += frameRateInterval;
        const fillPercentage = (elapsedTime / totalDuration) * 100;
        $progressBar.css('width', fillPercentage + '%');

        if (elapsedTime >= totalDuration) {
            elapsedTime = 0;

            $slides.eq(currentSlideIndex).removeClass('active');
            currentSlideIndex = (currentSlideIndex + 1) % $slides.length;
            $slides.eq(currentSlideIndex).addClass('active');
        }
    }

    // Start the interval
    rotationTimer = setInterval(runSliderLifecycle, frameRateInterval);

    // UPDATED: Pause only when mouse interacts directly inside the card frame bounds
    if ($sliderCard.length) {
        $sliderCard.on('mouseenter', function() {
            clearInterval(rotationTimer);
        }).on('mouseleave', function() {
            // Clear any leftover artifacts and restart safely
            clearInterval(rotationTimer);
            rotationTimer = setInterval(runSliderLifecycle, frameRateInterval);
        });
    }
});

// Parallax Setup

$(function() {
    var $el = $('.parallax-background');
    $(window).on('scroll', function () {
        var scroll = $(document).scrollTop();
        $el.css({
            'background-position':'50% '+(+.3*scroll)+'px'
        });
    });
});



// Mobile Navigation

$(document).ready(function(){

    $('.mobile-menu__link').on('click', function(e){
        e.preventDefault();
        $(this).closest('.mobile-menu').find('.offscreen-menu').toggleClass('active');
    });

    // Only bind submenu behavior inside the offscreen mobile menu
    $('.offscreen-menu').on('click', '.menu-item-has-children > a', function(e){
        e.preventDefault();
        const $parent = $(this).closest('.menu-item-has-children');
        $parent.children('.sub-menu').toggleClass('active');
        $(this).closest('.offscreen-menu').find('ul').first().toggleClass('hidden');
    });

});



// Book a Call — scroll to contact form on homepage; other pages via /#book-a-call
$(document).ready(function () {
    const CONTACT_ID = 'book-a-call';

    function scrollToContactForm() {
        const $target = $('#' + CONTACT_ID);
        if (!$target.length) {
            return;
        }

        const headerHeight = $('.header').outerHeight() || 90;
        const top = $target.offset().top - headerHeight;

        $('html, body').stop().animate({ scrollTop: top }, 600);
    }

    function closeMobileMenu() {
        $('.offscreen-menu').removeClass('active');
    }

    // Same-page smooth scroll (homepage)
    $(document).on('click', '.header .book-a-call > a, .header .menu-item.get-in-touch > a', function (e) {
        if (!$('body').hasClass('home') || !$('#' + CONTACT_ID).length) {
            return;
        }

        e.preventDefault();
        closeMobileMenu();
        scrollToContactForm();

        if (window.history && window.history.replaceState) {
            window.history.replaceState(null, '', '#book-a-call');
        }
    });

    // Arriving from another page with hash
    function scrollIfHashPresent() {
        if (window.location.hash !== '#book-a-call') {
            return;
        }

        scrollToContactForm();
    }

    scrollIfHashPresent();
    $(window).on('load', scrollIfHashPresent);
});



// Fancy Animations

// CTA Pull Left
$(document).ready(function(){

    // Left Time Line
    var left_tl = gsap.timeline();

    left_tl.to("#left-col", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to("#left-col", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Scroll Magic Triggers
    var left_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#left-col',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -400
    })
    .addTo(left_controller)
    .setTween(left_tl);
    
});


// CTA Pull Right
$(document).ready(function(){

    // Right Time Line
    var right_tl = gsap.timeline();

    right_tl.to("#right-col", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to("#right-col", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // CTA Box Triggers
    var right_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#right-col',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -400
    })
    .addTo(right_controller)
    .setTween(right_tl);

});



// Image With Text Pull Right
$(document).ready(function(){

    // Right Time Line
    var img_right_tl = gsap.timeline();

    img_right_tl.to("#right-text-block", {
        x: -100, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to("#right-text-block", {
        x: -100, y: 0, 
        duration: 3, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Triggers
    var image_text_right_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#right-text-block',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(image_text_right_controller)
    .setTween(img_right_tl);

});

// Image With Text Pull Left
$(document).ready(function(){

    // Left Time Line
    var img_left_tl = gsap.timeline();

    img_left_tl.to("#left-text-block", {
        x: 100, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to("#left-text-block", {
        x: 100, y: 0, 
        duration: 3, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Triggers
    var image_text_left_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#left-text-block',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(image_text_left_controller)
    .setTween(img_left_tl);
    
});

// Image With Text Image Pull Left
$(document).ready(function(){

    // Left Time Line
    var img_left_img_tl = gsap.timeline();

    img_left_img_tl.to("#left-image", {
        x: 0, y: 0, 
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to("#left-image", {
        x: 0, y: 0, 
        duration: 3, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Image Triggers
    var image_text_left_image_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#left-image-outer',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(image_text_left_image_controller)
    .setTween(img_left_img_tl);
    
});

// Image With Text Image Pull Right
$(document).ready(function(){

    // Right Time Line
    var img_right_img_tl = gsap.timeline();

    img_right_img_tl.to("#right-image", {
        x: 0, y: 0, 
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to("#right-image", {
        x: 0, y: 0, 
        duration: 3, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Image Triggers
    var image_text_right_image_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#right-image-outer',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(image_text_right_image_controller)
    .setTween(img_right_img_tl);
    
});

// Wide Image Above
$(document).ready(function(){

    // Right Time Line
    var wide_img_above_tl = gsap.timeline();

    wide_img_above_tl.to(".wide-image-above", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".wide-image-above", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Image Triggers
    var wide_img_above_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#wide-image-overlay',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(wide_img_above_controller)
    .setTween(wide_img_above_tl);
    
});

// Our Clients Outer
$(document).ready(function(){

    // Our Clients Outer Time Line
    var our_clients_tl = gsap.timeline();

    our_clients_tl.to(".our-clients-inner", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".our-clients-inner", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Image Triggers
    var our_clients_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#our-clients',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(our_clients_controller)
    .setTween(our_clients_tl);
    
});

// Our Clients Logos
$(document).ready(function(){

    // Logo Timeline
    var logo_tl = gsap.timeline();

    logo_tl.to(".logo-holder:nth-child(1) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(1) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(1) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(2) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(2) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(2) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(3) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(3) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(3) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(4) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(4) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(4) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(5) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(5) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(5) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(6) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(6) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(6) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(7) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(7) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(7) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(8) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(8) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(8) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(9) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(9) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(9) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(10) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(10) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(10) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(11) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(11) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(11) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    })
    .to(".logo-holder:nth-child(12) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(12) .logo-holder__logo", {
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        filter: "grayscale(0)"
    })
    .to(".logo-holder:nth-child(12) .logo-holder__logo", {
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 0.5,
        // filter: "grayscale(1)"
    });

    // Logo Triggers
    var logo_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.our-clients-inner',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -200
    })
    .addTo(logo_controller)
    .setTween(logo_tl);
    
});


// Blog Animations

// Blog Outer
$(document).ready(function(){

    // Our Clients Outer Time Line
    var blog_outer_tl = gsap.timeline();

    blog_outer_tl.to(".short-blog-inner", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".short-blog-inner", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Image With Text Image Triggers
    var blog_outer_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#short-blog',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -300
    })
    .addTo(blog_outer_controller)
    .setTween(blog_outer_tl);
    
});

// Left Blog
$(document).ready(function(){

    // Left Time Line
    var left_blog_tl = gsap.timeline();

    left_blog_tl.to(".blog-item:nth-child(1)", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".blog-item:nth-child(1)", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Scroll Magic Triggers
    var left_blog_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#short-blog',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -400
    })
    .addTo(left_blog_controller)
    .setTween(left_blog_tl);
    
});

// Right Blog
$(document).ready(function(){

    // Right Time Line
    var right_blog_tl = gsap.timeline();

    right_blog_tl.to(".blog-item:nth-child(2)", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".blog-item:nth-child(2)", {
        x: 0, y: 0, 
        duration: 2, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Scroll Magic Triggers
    var right_blog_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '#short-blog',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -400
    })
    .addTo(right_blog_controller)
    .setTween(right_blog_tl);
    
});



// Content Section Images
$(document).ready(function(){

    // Right Time Line
    var content_images_tl = gsap.timeline();

    content_images_tl.to(".image-holder:nth-child(1) .image-holder__img", {
        x: 0, y: 0, 
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".image-holder:nth-child(2) .image-holder__img", {
        x: 0, y: 0, 
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".image-holder:nth-child(3) .image-holder__img", {
        x: 0, y: 0, 
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    })
    .to(".image-holder:nth-child(4) .image-holder__img", {
        x: 0, y: 0, 
        duration: 1, 
        ease: "Power1.easeInOut",
        opacity: 1,
        scale: 1
    });

    // Scroll Magic Triggers
    var content_images_controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
        triggerElement: '.images-col',
        duration: 1000,
        triggerHook: 'onEntery',
        offset: -400
    })
    .addTo(content_images_controller)
    .setTween(content_images_tl);
    
});